export * from "./jira-service-management-pricing-page-v2.template";
